import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IMAGES } from "../../assets";
import { AuthContext } from "../../context";
import {
  updateBookPdfProgress,
  AddHighlightText,
  GetHighlightText,
  CheckUsersCount,
  getLastBookProgress,
} from "../../api";
import { STORAGE_KEY, STRINGS } from "../../constants";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import { pdfjs } from "react-pdf";
// import {Documet} from "react-pdf/renderer"
import "./ReadBook.css";
import { FILE_URL } from "../../constants/Constants";
import { useTranslation } from "react-i18next";

import { Worker, Viewer, SpecialZoomLevel } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

import { pageNavigationPlugin } from "@react-pdf-viewer/page-navigation";
import "@react-pdf-viewer/page-navigation/lib/styles/index.css";
import useIsMobile from "../../components/useIsMobile";
import {
  AreaHighlight,
  Highlight,
  PdfHighlighter,
  PdfLoader,
  Popup,
  Tip,
} from "react-pdf-highlighter";

import flipSound from "../../assets/audio/page-flip.mp3";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
const ReadBook = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const bookPdfItem = location?.state?.bookPdfItem;
  const pageNum = location?.state?.pageNum || 1;

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(pageNum);
  const [bookUserCount, setBookUserCount] = useState(0);
  const [showLimitExceedPopup, setShowLimitExceedPopup] = useState(false);
  const [bookReadingPercent, setBookReadingPercent] = useState(0);
  const [showContent, setShowContent] = useState(true);
  const [lastViewedPage, setLastViewedPage] = useState(1);
  const [highlights, setHighlights] = useState([]);
  const [animationClass, setAnimationClass] = useState("");

  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const pageNavigationPluginInstance = pageNavigationPlugin({
    onPageChange: (e) => {
      setPageNumber(e.currentPage);
      handlePageChange(e);
    },
  });

  const resetHash = () => {
    document.location.hash = "";
  };
  // const convertToProperMarathi = (text) => {
  //   return transliterate(text, { from: "iast", to: "devanagari" });
  // };

  const removeHighlight = (id) => {
    setHighlights((prevHighlights) =>
      prevHighlights.filter((highlight) => highlight.id !== id)
    );
  };

  const HighlightPopup = ({ comment, id }) =>
    comment.text ? (
      <div className="Highlight__popup">
        {comment.emoji} {comment.text}
        <button
          className="ml-2 text-red-500"
          onClick={() => removeHighlight(id)}
        >
          Remove
        </button>
      </div>
    ) : null;

  const scrollViewerToRef = useRef(null);
  // const addHighlight = useCallback((highlight) => {
  //   setHighlights((prevHighlights) => [...prevHighlights, highlight]);
  // }, []);

  const addHighlight = useCallback((highlight) => {
    const id = String(Math.random());
    setHighlights((prevHighlights) => [
      ...prevHighlights,
      { ...highlight, id },
    ]);
  }, []);

  const scrollToHighlightFromHash = () => {
    // scrollToTop();
  };

  const scrollViewerTo = (position) => {
    if (scrollViewerToRef.current) {
      scrollViewerToRef.current(position);
    }
  };

  const normalizeText = (text) => {
    return text.normalize("NFC");
  };

  // const [pageNumber, setPageNumber] = useState(1);
  // const numPages = pdfDocument?.numPages || 1;
  const handleNextPage = () => {
    const audio = new Audio(
      "https://ebook.prometteur.in/front/static/media/page-flip.47d6f47e1cc6783855bd.mp3"
    ); // Adjust the path according to your build output
    audio.play();

    if (pageNumber < numPages) {
      setPageNumber(pageNumber + 1);
    }
    // scrollToTop();
  };

  const handlePreviousPage = () => {
    const audio = new Audio(
      "https://ebook.prometteur.in/front/static/media/page-flip.47d6f47e1cc6783855bd.mp3"
    ); // Adjust the path according to your build output

    audio.play();
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1);
    }
    // scrollToTop();
  };

  useEffect(() => {
    if (animationClass) {
      const timer = setTimeout(() => setAnimationClass(""), 600); // Match the duration of the animation
      return () => clearTimeout(timer);
    }
  }, [animationClass]);

  const { GoToFirstPage, GoToLastPage, GoToNextPage, GoToPreviousPage } =
    pageNavigationPluginInstance;

  useEffect(() => {
    getFileUrl();
    updateHighlightedText();
    getBookProgress();
    checkUserCount();

    // return () => {
    //   onUpdatePdfProcress(false);
    // };
  }, []);

  useEffect(() => {
    getAndSetlocalPageItem();
  }, [numPages]);

  async function getBookProgress() {
    const params = {
      bookId: bookPdfItem?._id,
      userId: user?.userInfo?._id,
    };

    const result = await getLastBookProgress(params);

    if (result?.status) {
      const response = result?.data?.eBookProgress.books.readingPercent;
      setBookReadingPercent(response);
    } else {
      console.error(result?.error);
    }
  }

  async function getAndSetlocalPageItem() {
    // Calculate the current page number based on reading percentage and total pages
    const currentPageNumber = Math.ceil(
      (bookReadingPercent / 100) * numPages - 1
    );
    setPageNumber(currentPageNumber === 0 ? 1 : currentPageNumber);
    if (location?.state?.pageNum) {
      setPageNumber(pageNum);
    }
    // Retrieve the stored page number from local storage
    let res = localStorage.getItem(STORAGE_KEY.BOOK_PAGE_NUMBER);

    if (res) {
      // Parse the stored data
      res = JSON.parse(res);

      // Check if the book's ID exists in the stored data
      if (res[bookPdfItem?._id]) {
        // Split the stored value to get individual page numbers
        let pages = res[bookPdfItem?._id].split(" ");

        // If there are stored pages, set the last page number to the last one in the array
        if (pages.length > 0) {
          const lastPageNumber = Number(pages[pages.length - 1]);
        }
      }
    }
  }

  const urlData = location?.state?.bookPdfItem?.bookPdf;
  const pdfUrlLInk = urlData?.replace(/^http:\/\//i, "https://");
  const pdfUrl = `${FILE_URL}${pdfUrlLInk}`;
  async function getFileUrl() {
    const arrayStr = localStorage.getItem(STORAGE_KEY.DOWNLOADED_BOOK_ITEM);
    if (arrayStr) {
      let array = JSON.parse(arrayStr);
      if (array.some((e) => e._id == bookPdfItem._id)) {
        const index = array.findIndex((e) => e._id == bookPdfItem._id);
        if (index >= 0) {
          const book = array[index];
          return;
        }
      }
    }
  }
  // check the usercount of perticular book
  async function checkUserCount() {
    const params = {};
    const result = await CheckUsersCount(params);
    result.data.eBookProgress?.map((item) => {
      if (item._id === bookPdfItem?._id) {
        setBookUserCount(item.userCount);
        if (item.userCount > 10) {
          // setShowLimitExceedPopup(true);
        }
      }
    });
  }
  // function for purchaselicence

  async function onUpdatePdfProcress(exit) {
    const params = {
      userId: user?.userInfo?._id,
      bookId: bookPdfItem?._id,
      totalPages: numPages,
      readPages: pageNumber + 1,
      bookProgress: exit ?? true,
      instituteId: user?.userInfo?.createdBy,
    };

    const result = await updateBookPdfProgress(params);
    if (!result?.status) {
      // setShowLimitExceedPopup(true);
    }
  }

  async function updateHighlightedText() {
    const params = {
      userId: user?.userInfo?._id,
      bookId: bookPdfItem?._id,
    };
    const result = await GetHighlightText(params);
    result.data.data?.map((item) => setHighlights(item.HighlightText));
  }

  const addHighlightAsync = async () => {
    const params = {
      userId: user?.userInfo?._id,
      bookId: bookPdfItem?._id,
      HighlightText: highlights,
    };
    try {
      const result = await AddHighlightText(params);
    } catch (error) {
      console.error("Error adding highlight:", error);
      // Handle error case
    }
  };

  useEffect(() => {
    if (highlights?.length > 0) addHighlightAsync();
  }, [highlights]);

  const handleBackNavigate = () => {
    onUpdatePdfProcress(false);
    navigate(-1);
    addHighlightAsync();
  };

  useEffect(() => {
    const loadDocument = async () => {
      try {
        const pdf = await pdfjs.getDocument(pdfUrl).promise;
        const numPages = pdf.numPages;
        setNumPages(numPages);

        const pageElement = document.querySelector(
          `[data-page-number="${pageNumber}"]`
        );
        if (pageElement) {
          // Set the width of PdfHighlighter if found
          if (document.querySelector(".PdfHighlighter")) {
            document.querySelector(".PdfHighlighter").style.width =
              pageElement.style.width;
          }
          // Scroll to the page element
          // setTimeout(() => {
          //   pageElement.scrollIntoView();
          // }, 100);
        }
      } catch (error) {
        console.error("Error loading PDF:", error);
      }
    };

    if (pdfUrl && showContent) {
      loadDocument();
    }
  }, [pdfUrl, showContent, pageNumber]);

  // add logic to scroll the page as per page number and redirect
  useEffect(() => {
    let scrollPage;

    const pageElement = document.querySelector(
      `[data-page-number="${pageNumber}"]`
    );
    if (pageElement) {
      scrollPage = setTimeout(() => {
        pageElement.scrollIntoView();
        window.scroll(0, 0);
      }, 100);
    }

    return () => {
      clearTimeout(scrollPage);
    };
  }, [pageNumber, lastViewedPage]); //here setTimeout is 100 when pageNumber change

  const handleBackToBook = () => {
    setShowContent(true);
    setLastViewedPage(pageNumber); // Save the last viewed page number
  };
  // Modify the useEffect to set the pageNumber to the lastViewedPage when showContent is true
  useEffect(() => {
    if (showContent) {
      setPageNumber(lastViewedPage);
    }
  }, [showContent, lastViewedPage]);

  const handlePageChange = (e) => {
    setAnimationClass(""); // Clear the animation class to reset
    setTimeout(() => setAnimationClass("flip-animation"), 10);
    // setAnimationClass("flip-animation");
    const audio = new Audio(flipSound);
    audio.play();
    setPageNumber(e?.currentPage);
    setNumPages(e?.doc?._pdfInfo?.numPages);
    onUpdatePdfProcress();
    setTimeout(() => {
      setAnimationClass("");
    }, 600);
    scrollToTop();

    // setCurrentPage(currentPage);
    // setTotalPages(numberOfPages);
  };

  window.addEventListener("beforeunload", (ev) => {
    ev.preventDefault();
    return (ev.returnValue = "Are you sure you want to close?");
  });

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // useEffect(() => {
  //   const audio = new Audio(flipSound);
  //   audio.play();
  // }, []);
  return (
    <div
      // onContextMenu={(e) => e.preventDefault()}
      // onCopy={(e) => preventCopyPaste(e)}
      className="h-full bg-white rounded-2xl p-4 relative w-full px-20"
    >
      {showLimitExceedPopup && (
        <div className="limit-exceed-popup min-h-96 h-full w-full">
          <div className="popup-div">
            <p>{t(STRINGS?.limit_exceeds)}</p>
            <div className="navigate-div">
              <button
                className="px-4 py-2 border-slate-400 border rounded-full cancel-btn"
                onClick={handleBackNavigate}
              >
                {" "}
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="my-2 flex items-center justify-between bg-white sticky top-0 z-50 py-1">
        <button
          className="w-8 h-8 text-lg font-bold border-slate-400 border flex items-center justify-center rounded-full"
          onClick={handleBackNavigate}
        >
          <img
            className="w-full h-full"
            alt="backarrow"
            src={IMAGES?.backIcon}
          />
        </button>
        <div className="mx-auto">
          <h2 className="mx-auto text-lg font-bold text-center">
            {bookPdfItem?.bookName}
          </h2>
          <div className="flex items-center justify-center gap-2">
            <GoToPreviousPage>
              {(props) => (
                <button
                  className="h-8 w-8 rounded-full border"
                  disabled={pageNumber <= 1}
                  onClick={handlePreviousPage}
                >
                  <img
                    alt="prev"
                    className="w-full h-full"
                    src={IMAGES?.backIcon}
                  />
                </button>
              )}
            </GoToPreviousPage>
            <span>
              {" "}
              <span className="text-base font-semibold">{pageNumber}</span>{" "}
              <span className="text-base font-medium text-[#8A8A8A]">
                / {numPages}
              </span>
            </span>
            <GoToNextPage>
              {(props) => (
                <button
                  className="h-8 w-8 rounded-full border"
                  disabled={pageNumber >= numPages}
                  onClick={handleNextPage}
                >
                  <img
                    alt="next"
                    className="w-full h-full rotate-180"
                    src={IMAGES?.backIcon}
                  />
                </button>
              )}
            </GoToNextPage>
          </div>
        </div>
      </div>
      <div className="relative flex items-center justify-center w-full ">
        <div
          style={{
            height: "100vh",
            overflowY: "hidden",
            width: "75%",
          }}
          // onContextMenu={(e) => e.preventDefault()}
          className="flex items-center h-full justify-center relative"
          ref={scrollViewerToRef}
          // onCopy={handleCopy}
        >
          {/* <Worker
          workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}
        >
          <Viewer
            defaultScale={isMobile ? SpecialZoomLevel.PageFit : 1.3}
            fileUrl={pdfUrl}
            plugins={[pageNavigationPluginInstance]}
            onPageChange={handlePageChange}
            initialPage={pageNumber}
            // defaultScale={SpecialZoomLevel.PageFit}
          />
        </Worker> */}

          {/* <div className="top-0  h-full w-full absolute left-0 bg-red-400"></div> */}
          <PdfLoader url={pdfUrl} beforeLoad={<p>Loading...</p>}>
            {(pdfDocument) => (
              <PdfHighlighter
                pdfDocument={pdfDocument}
                pageNumber={pageNumber}
                enableAreaSelection={(event) => event.altKey}
                onScrollChange={resetHash}
                pdfScaleValue="page-width"
                scrollRef={(scrollTo) => {
                  scrollViewerTo = scrollTo;
                  scrollToHighlightFromHash();
                }}
                onSelectionFinished={(
                  position,
                  content,
                  hideTipAndSelection,
                  transformSelection
                ) => (
                  <Tip
                    onOpen={transformSelection}
                    onConfirm={(comment) => {
                      addHighlight({ content, position, comment });
                      hideTipAndSelection();
                    }}
                  />
                )}
                highlightTransform={(
                  highlight,
                  index,
                  setTip,
                  hideTip,
                  viewportToScaled,
                  screenshot,
                  isScrolledTo
                ) => {
                  const isTextHighlight = !Boolean(
                    highlight.content && highlight.content.image
                  );
                  const component = isTextHighlight ? (
                    <Highlight
                      isScrolledTo={isScrolledTo}
                      position={highlight.position}
                      comment={highlight.comment}
                    />
                  ) : (
                    <AreaHighlight
                      isScrolledTo={isScrolledTo}
                      highlight={highlight}
                      onChange={(boundingRect) => {
                        updateHighlightedText(
                          highlight.id,
                          { boundingRect: viewportToScaled(boundingRect) },
                          { image: screenshot(boundingRect) }
                        );
                      }}
                    />
                  );

                  return (
                    <Popup
                      popupContent={
                        <HighlightPopup {...highlight} id={highlight.id} />
                      }
                      onMouseOver={(popupContent) =>
                        setTip(highlight, () => popupContent)
                      }
                      onMouseOut={hideTip}
                      key={index}
                      children={component}
                    />
                  );
                }}
                highlights={highlights}
              />
            )}
          </PdfLoader>
        </div>
      </div>
    </div>
  );
};

export default ReadBook;
